import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {  FilterItem, FilterType, InputType, PagingOptions, TagsInputOptions, TextBoxOptions } from 'bnsights-control-library';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { DepartmentModel } from '../../shared/models/DepartmentModels/DepartmentModel';
import { DepartmentUsersIDRequestModel } from '../../shared/models/DepartmentModels/DepartmentUsersIDRequestModel';
import { DepartmentService } from '../../shared/Services/DepartmentService.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bnsights-utilities-library';
@Component({
  selector: 'lib-department-info',
  templateUrl: './department-info.component.html',
})
export class DepartmentInfoComponent implements OnInit {
  //Page requirements
  ShowPageContent: boolean = false;
  AuthToken: string = ""
  language: string = ""
  SubheaderTitle: string;
  ShowToolbar = true;
  ShowbreadCrumb = true;
  BreadcrumbTitle = this.UtilityService.getResourceValue('Departments');
  ApiUrl = "/api/admin/Department/"

  //Filter and paging components
  UserDepartmentForm = new FormGroup({});
  searchTextBox: TextBoxOptions;
  TextInputFilter: FilterItem;
  DepartmentIdTextBox: TextBoxOptions;
  DepartmentIdTextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  UserDepartmentPaging: PagingOptions;
  UserDepartmentPagingResult: any[] = [];
  @ViewChild('UserDepartmentPagingViewElement', { static: false }) pagingElement: ElementRef;

  //Parent department data
  DepartmentId: string = ""
  Department: DepartmentModel = new DepartmentModel();

  //Add Model Controls
  AddUsersToDepartmentForm = new FormGroup({});
  UserAutoComplete: TagsInputOptions;
  @ViewChild('CloseAddUsersToDepartment', { static: false }) CloseAddUsersToDepartment: ElementRef;

  //delete  Model Controls
  deleteUserId: number;
  @ViewChild('CloseDeleteUserFromDepartmentModal', { static: false }) CloseDeleteUserFromDepartmentModal: ElementRef;

  constructor(private activatedRoute: ActivatedRoute, public UtilityService: UtilityService, private DepartmentService: DepartmentService,
    private environmentService: EnvironmentService, private pageInfoService: PageInfoService, private authService: AuthService,
    private BBSFTranslateService: BBSFTranslateService,
    private modalService: NgbModal) {
    this.activatedRoute.params.subscribe(params => {
      this.DepartmentId = params['id'];
    });
  }
  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    this.BBSFTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.UtilityService.getCurrentLanguage();
    this.initializePage();
    this.loadBreadCrumpData();
  }


  //Paging functions
  reinitializeUserDepartmentPaging() {
    let element = this.pagingElement as any;
    element.ReinitializePaging();
  }

  updateUserDepartmentPaging() {
    let element = this.pagingElement as any;
    element.UpdatePaging();
  }

  setUserDepartmentListResult(result) {
    this.UserDepartmentPagingResult = result
    this.ShowPageContent = true;
    this.UtilityService.stopBlockUI()
  }

  resetFilters() {
    this.UserDepartmentForm.controls["searchTextBox"].setValue(null);
    let element = this.pagingElement as any;
    element.ReinitializePaging();
  }

  //Get parent department name and set page title and breadcrumbs
  loadBreadCrumpData() {
    this.DepartmentService.getDepartmentInfo(this.DepartmentId).subscribe((result) => {
      let resultModel = result as any
      this.SubheaderTitle = resultModel.val.departmentNamec;
      PageInfoService.PageTitle = this.SubheaderTitle
      PageInfoService.PageBreadcrumbs = [
        { title: this.UtilityService.getResourceValue("Home"), path: '/Admin/Home', isSeparator: false, isActive: false },
        { title: '', path: '', isSeparator: true, isActive: false },
        { title: this.UtilityService.getResourceValue("Departments"), path: '/Admin/Departments/Departments', isSeparator: false, isActive: false },
        { title: '', path: '', isSeparator: true, isActive: false }

      ];

      this.pageInfoService.calculateTitle();
      this.pageInfoService.calculateBreadcrumbs();
    });
  }

    //Initialize filters and paging
  initializePage() {
    // TextBox inti
    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.HideLabel = true
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.UtilityService.getResourceValue("SearchByNameOrEmail");

    this.DepartmentIdTextBox = new TextBoxOptions();
    this.DepartmentIdTextBox.Name = "DepartmentIdTextBox"
    this.DepartmentIdTextBox.LabelKey = "DepartmentIdTextBox"
    this.DepartmentIdTextBox.Type = InputType.Text
    this.DepartmentIdTextBox.Value = this.DepartmentId;
    this.DepartmentIdTextBox.Placeholder = this.UtilityService.getResourceValue("SearchByName")

    this.TextInputFilter = new FilterItem();
    this.TextInputFilter.FormControlName = "searchTextBox"
    this.TextInputFilter.ActionParameterName = "searchText"
    this.TextInputFilter.IsFormControl = true
    this.TextInputFilter.FilterType = FilterType.TextBox

    this.DepartmentIdTextInputFilter = new FilterItem();
    this.DepartmentIdTextInputFilter.FormControlName = "DepartmentIdTextBox"
    this.DepartmentIdTextInputFilter.ActionParameterName = "DepartmentId"
    this.DepartmentIdTextInputFilter.IsFormControl = true
    this.DepartmentIdTextInputFilter.FilterType = FilterType.TextBox

    this.UserDepartmentPaging = new PagingOptions();
    this.UserDepartmentPaging.ActionPostURL = this.environmentService.getBaseUrl() + this.ApiUrl + 'GetUsersByFilter';
    this.UserDepartmentPaging.OnKeyPressFiltersControlNames = ["searchTextBox", "DepartmentIdTextBox"]
    this.UserDepartmentPaging.Filters = [this.TextInputFilter, this.DepartmentIdTextInputFilter]
    this.UserDepartmentPaging.PageSize = 10
    this.UserDepartmentPaging.HidePaginationWhenPageSizeEqualOne = true
    this.UserDepartmentPaging.ShowPageSizeOption = true
    this.UserDepartmentPaging.ShowFirstAndLast = true
    this.UserDepartmentPaging.ValidationToken = this.authService.authorizationHeaderValue()
    this.IsFilterLoaded = true;
  }

  //Add user to department
  showAddUserToDepartmentModal(AddUserToDepartmentModal) {

    this.UtilityService.startBlockUI();
    this.AddUsersToDepartmentForm = new FormGroup({})

    this.UserAutoComplete = new TagsInputOptions();
    this.UserAutoComplete.Name = "UserAutoComplete";
    this.UserAutoComplete.LabelKey = "Users";
    this.UserAutoComplete.IsRequired = true;
    this.UserAutoComplete.Value = null;
    this.UserAutoComplete.ActionURL = this.environmentService.getBaseUrl() + this.ApiUrl + "AutoCompleteUserList"
    this.UserAutoComplete.ValidationToken = this.AuthToken
    this.modalService.open(AddUserToDepartmentModal);
    this.UtilityService.stopBlockUI();

  }

  addUserToDepartment() {
    if (this.AddUsersToDepartmentForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddUsersToDepartmentForm.value;
      let AddModel: DepartmentUsersIDRequestModel = new DepartmentUsersIDRequestModel();
      for (let index = 0; index < ResultModel.UserAutoComplete.length; index++) {
        const key = ResultModel.UserAutoComplete[index].key;
        AddModel.UsersIDs.push(Number(key))

      }
      AddModel.DepartmentId = Number(this.DepartmentId);
      this.DepartmentService.addUsersToDepartment(AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.pagingElement as any;
        element.ReinitializePaging();
      }, (error) => {

      })
    }
  }

//Delete user from department
  showDeleteUserFromDepartmentModal(user: any, deleteUserDepartmentModal) {
    this.UtilityService.startBlockUI();
    this.deleteUserId = user.id;

    this.modalService.open(deleteUserDepartmentModal);
    this.UtilityService.stopBlockUI();
  }

  deleteUserFromDepartment() {
    this.DepartmentService.deleteUserFromDepartment(this.deleteUserId.toString(), this.DepartmentId).subscribe((result) => {
      this.deleteUserId = 0;
      this.modalService.dismissAll()
      let element = this.pagingElement as any;
      element.ReinitializePaging();
    });
  }




}
